import React from 'react'
import './App.css'
import Home from './component/Home'
import Contact from './component/Contact'
import Blog from './component/Blog'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'

const App = () => {

  return (
    <Router>
      <Routes>
        <Route exact path='/home' element={< Home />}></Route>
        <Route exact path='/contact' element={< Contact />}></Route>
           <Route exact path='/blog' element={< Blog />}></Route>
        <Route path="*" element={<Navigate to="/home" replace />}></Route>
      </Routes>
    </Router>




  )
}

export default App